import React, { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../../../redux/hooks';
import Box from '@mui/material/Box';
import moment from 'moment';

// Icons 

import MoreVertIcon from '@mui/icons-material/MoreVert';
import getStatusColor from '../../../../util/style/getStatusColor';
import { getGroupMemberInfo } from '../../../../routes/doctor/account';
import getCapitalizedString from '../../../../util/style/getCapitalizedString';
import { useTranslation } from 'react-i18next';
import Dropdown from './Dropdown';

type Props = {
  item: any; 
};


const GroupAccessRow: React.FC<Props> = ({ item }) => {

  const { t } = useTranslation(); 

  const colors = useAppSelector(state => state.theme.colors); 
  const accountInfo = useAppSelector(state => state.meta.accountInfo); 

  const [account, setAccount] = useState(null) as any; 
  const [status, setStatus] = useState(''); 
  const [positionX, setPositionX] = useState(0); 
  const [positionY, setPotisionY] = useState(0); 

  // -- 

  const handleGroupMemberInfo = async () => { 

    const res = await getGroupMemberInfo(item._id) as any; 

    if (res.data.status === 200) { 

      setAccount(res.data.doctor); 

      if (res.data.isMainDoctorId) { 

        setStatus('admin'); 

      }; 

    }; 

  }; 

  // -- 

  useEffect(() => { 

    if (item) { 

      handleGroupMemberInfo(); 

      setStatus(item?.status); 

    }; 

  },[item]); 

  // -- 

  return (

    <Box 
      sx={{ 
      display: 'flex', 
      flexDirection: 'row',
      alignItems: 'center', 
      width: '100%',
      fontSize: 12, 
      height: 50,
      cursor: (status === 'admin') ? 'default' : 'pointer', 
      '&:hover': { backgroundColor: colors?.sectionHover, cursor: 'default' }
    }}>

            <div style={{ 
                display: 'flex', 
                flexDirection: 'row',
                alignItems: 'center',
                width: '22%',
                marginLeft: '3%',  
                textAlign: 'left',
                overflow: 'hidden',
            }}>{account?.firstName} {account?.lastName}</div>

            <div style={{ 
                width: '20%', 
                textAlign: 'left',
                overflow: 'hidden',
            }}>
                <strong style={{ 
                    padding: 5,
                    borderRadius: 7,
                    backgroundColor: getStatusColor(status), 
                    color: 'white', 
                }}>
                    {t(status)}
                </strong>
            </div>

            <div style={{ 
                width: '35%', 
                textAlign: 'left',
                overflow: 'hidden', 
            }}>{account?.email}</div>

            <div style={{ 
                width: '15%', 
                textAlign: 'left',
                overflow: 'hidden', 
            }}>{moment(account?.lastActive).format('LL')}</div>

            <div style={{ 
                width: '5%', 
                textAlign: 'left',
                overflow: 'hidden', 
            }}>
                <Box
                  sx={{ 
                    display: 'flex', 
                    flexDirection: 'row',
                    alignItems: 'center', 
                    justifyContent: 'space-evenly', 
                    width: 40,
                    height: 40,
                    borderRadius: '50%',
                    cursor: 'pointer', 
                    color: (status === 'admin') ? 'rgb(200, 200, 200)' : colors?.text, 
                    '&:hover': { backgroundColor: (status === 'admin') ? 'transparent' : 'rgba(45, 153, 207, 0.6)'}
                  }}
                >
                  <MoreVertIcon></MoreVertIcon>
                </Box>

            </div>
            
    </Box>

  );

};

export default GroupAccessRow;